import React from 'react';
import styles from './CompanyCard.module.css';
import { Favicon } from './Favicon';

interface CompanyCardProps {
  name: string;
  address_city?: string;
  address_country?: string;
  address_zip_code?: string;
  website?: string;
  isDarkMode?: boolean;
}

export const CompanyCard: React.FC<CompanyCardProps> = ({
  name,
  address_zip_code,
  address_city,
  address_country,
  website,
  isDarkMode = false
}) => {

  const formatLocation = () => {
    const city = address_city;
    const country = address_country;
    const state = address_zip_code;

    const parts = [city, state, country].filter(Boolean);
    return parts.join(', ');
  };


  return (
    <div className={styles.companyCard}>

      {/* Company icon */}
      <div className={styles.companyIcon}>
        {website ? (
          <Favicon
            websiteUrl={website}
            size={80}
            retinaMultiplier={4}
            className={styles.favicon}
          />
        ) : (
          <img
            src={isDarkMode ? "/assets/icons/building.2.svg" : "/assets/icons/building.2.black.svg"}
            alt="Company Icon"
            width={80}
            height={80}
            className={styles.defaultIcon}
          />
        )}
      </div>

      {/* Company info */}
      <div className={styles.companyInfo}>

        {/* Company name */}
        <h2 className={styles.companyName}>
          {name}
        </h2>

        {/* Company location */}
        <p className={styles.companyAddress}>
          {formatLocation() || 'Unknown location'}
        </p>

      </div>
    </div>
  );
};
